export function appendToDocumentBody<T extends Node>(node: T): T {
  const parent = document.body ?? document.documentElement;
  if (!parent) {
    throw new Error("Document is not ready.");
  }
  parent.appendChild(node);
  return node;
}

/**
 * Hand the browser a text file to save.
 *
 * Here rather than in each tool because the two free server-owner tools each
 * arrived with their own copy of these nine lines, written blind to one
 * another, and they had already drifted: one appended through
 * `appendToDocumentBody` and one reached for `document.body` directly, which
 * throws in a test environment that has not built a body yet. There is nothing
 * tool-specific in it — a blob, an object URL, a detached anchor, and a revoke
 * that has to happen or the blob stays in memory for the life of the tab.
 *
 * `mime` is a parameter rather than a default because the exporters emit four
 * different types and a `.csv` served as `text/plain` opens in a text editor
 * instead of a spreadsheet.
 */
export function downloadTextFile(filename: string, text: string, mime: string): void {
  const blob = new Blob([text], { type: `${mime};charset=utf-8` });
  const href = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = href;
  anchor.download = filename;
  appendToDocumentBody(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(href);
}
